<script>
	import { onMount } from 'svelte';
    import morantarotImg from '../img/morantarot.png';
    import TTSImg from '../img/TTS.png';
    import exImg from '../img/Sample.png';
	import ReMoranTarotImg from '../img/ReMoranTarotImg.png';
	
	// 포트폴리오 프로젝트 데이터
	const projects = [
		{
			title: "Moran's Tarot",
			description: "This is the first web I made, based on what I learned by studying by myself. A website for the promotion of private businesses, it was created to promote fortune-telling services such as tarot.",
			technologies: ["HTML", "CSS", "JavaScript", "Figma", "GitHub"],
			year: 2023,
			image: morantarotImg,
			url: "https://moran-tarot.com/"
		},
		{
			title: "Discord TTS Bot",
			description: "Made a Discord bot exclusively for Korean. Made it by adding various features together to improve the inconvenience I had previously.",
			technologies: ["Python", "MongoDB", "GitHub"],
			year: 2024,
			image: TTSImg,
			url: "https://koreanbots.dev/bots/1263408829325119640"
		},
		{
			title: "Moran's Tarot Renewal",
			description: "I renewed Moran's Tarot web page that I made before. I applied Sveld and Tailwind CSS to improve development and maintenance efficiency. Additionally, I tried UX/UI design with Figma for UI quality.",
			technologies: ["Svelte", "Typescript", "Tailwind CSS", "Figma", "GitHub"],
			year: 2025,
			image: ReMoranTarotImg
		},
		{
			title: "Ex",
			description: "Ex",
			technologies: ["JavaScript"],
			year: 2024,
			image: exImg // 이미지 경로 추가 필요
		},
        {
			title: "Ex",
			description: "Ex",
			technologies: ["JavaScript"],
			year: 2024,
			image: exImg // 이미지 경로 추가 필요
		},
		{
			title: "Ex",
			description: "Ex",
			technologies: ["JavaScript"],
			year: 2024,
			image: exImg // 이미지 경로 추가 필요
		}
	];
	
	// 필터링 기능
	let selectedTech = "All";
	
	$: filteredProjects = selectedTech === "All" 
		? projects 
		: projects.filter(project => project.technologies.includes(selectedTech));
	
	// 모든 기술 목록 (중복 제거)
	let allTechnologies = ["All"];
	
	onMount(() => {
		const techSet = new Set();
		projects.forEach(project => {
			project.technologies.forEach(tech => techSet.add(tech));
		});
		allTechnologies = ["All", ...Array.from(techSet)];
	});
</script>

<div class="portfolio-container">
	<h1>Portfolio</h1>
	
	<div class="filter-container">
		<span>Filter by technology:</span>
		<div class="filter-buttons">
			{#each allTechnologies as technology}
				<button 
					class:active={selectedTech === technology}
					on:click={() => selectedTech = technology}>
					{technology}
				</button>
			{/each}
		</div>
	</div>
	
	<div class="projects-grid">
		{#each filteredProjects as project}
			<a href={project.url} target="_blank" rel="noopener noreferrer" class="project-card-link" >
				<div class="project-card">
					<div class="project-image">
						<img src={project.image} alt={project.title} />
					</div>
					<div class="project-info">
						<h3>{project.title}</h3>
						<p class="project-year">{project.year}</p>
						<p class="project-description">{project.description}</p>
						<div class="project-tech">
							{#each project.technologies as tech}
								<span class="tech-tag">{tech}</span>
							{/each}
						</div>
					</div>
				</div>
			</a>
		{/each}
	</div>
</div>

<style>
	.portfolio-container {
		max-width: 1200px;
		margin: 80px auto 0;
		padding: 0 20px;
	}

	h1 {
		font-size: var(--font-size-title, 2rem);
		margin-bottom: 1.5rem;
		color: var(--color-text, #000000);
	}
	
	.filter-container {
		margin-bottom: 2rem;
	}
	
	.filter-buttons {
		display: flex;
		flex-wrap: wrap;
		gap: 0.5rem;
		margin-top: 0.5rem;
	}
	
	.filter-buttons button {
		background: none;
		border: 2px solid #eee;
		padding: 0.5rem 1rem;
		border-radius: 20px;
		cursor: pointer;
		font-size: 0.9rem;
		transition: all 0.2s ease;
        color: #ffffff;
	}
	
	.filter-buttons button:hover {
		background-color: #f5f5f5;
        color: #383838;
	}
	
	.filter-buttons button.active {
		background-color: #383838;
		color: white;
		border-color: #383838;
	}
	
	.projects-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
		gap: 2rem;
	}
	
	.project-card {
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
		transition: transform 0.3s ease;
	}
	
	.project-card:hover {
		transform: translateY(-5px);
	}
	
	.project-image {
		height: 200px;
		overflow: hidden;
	}
	
	.project-image img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	
	.project-info {
		padding: 1.5rem;
	}
	
	h3 {
		margin: 0 0 0.5rem 0;
		font-size: 1.2rem;
	}
	
	.project-year {
		color: #a1a1a1;
		font-size: 0.9rem;
		margin: 0 0 1rem 0;
	}
	
	.project-description {
		margin: 0 0 1rem 0;
		color: #a1a1a1;
	}
	
	.project-tech {
		display: flex;
		flex-wrap: wrap;
		gap: 0.5rem;
	}

	.project-card-link,
	.project-card-link:hover,
	.project-card-link:visited,
	.project-card-link:active,
	.project-card-link:focus {
		text-decoration: none !important;
		color: inherit !important;
		display: block;
	}
	
	.tech-tag {
		background-color: #f1f1f1;
		padding: 0.3rem 0.6rem;
		border-radius: 4px;
		font-size: 0.8rem;
		color: #333;
	}
	
	/* 반응형 디자인 */
	@media (max-width: 768px) {
		.projects-grid {
			grid-template-columns: 1fr;
		}
	}
</style>